import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrdersState, Order } from '../../types/orders';

const initialState: OrdersState = {
  currentOrder: null,
  orders: [],
  selectedTableId: null,
  loading: false,
  error: null,
};

export const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setCurrentOrder: (state, action: PayloadAction<Order | null>) => {
      state.currentOrder = action.payload;
    },
    setSelectedTable: (state, action: PayloadAction<string | null>) => {
      state.selectedTableId = action.payload;
      if (action.payload === null) {
        state.currentOrder = null;
      }
    },
    clearCurrentOrder: (state) => {
      state.currentOrder = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setCurrentOrder,
  setSelectedTable,
  clearCurrentOrder,
  setLoading,
  setError,
  clearError,
} = ordersSlice.actions;

export default ordersSlice.reducer;